export enum StoreAction {
    // Popups
    OPEN_POPUP = "OPEN_POPUP",
    CLOSE_POPUP = "CLOSE_POPUP",
    SET_OPEN_MOVE_POPUP = "SET_OPEN_MOVE_POPUP",
}
